window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import Interface from 'theme/index.js';
import Favorites from 'theme/favorites.js';

(async () => {
    await Interface();
    Favorites();
})();